export const getMultiTariffsListMobileIds = (
    products: Record<
        number,
        {
            yearProduct?: { id: string };
            monthProduct?: { id: string };
        }
    >
) => {
    return Object.values(products).reduce<string[]>((ids, { yearProduct, monthProduct }) => {
        return ids.concat(...([yearProduct?.id, monthProduct?.id].filter(Boolean) as string[]));
    }, []);
};
